import imageCompression from "browser-image-compression";

const compressImage = async (file, options = {}) => {
    if (!file) {
        return file
    }

    if (file.size < 5 * 1024 * 1024) {
        return file
    }

    const defaultOptions = {
        maxSizeMB: 5,
        useWebWorker: true,
    }

    try {
        const compressedFile = await imageCompression(file, {
            ...defaultOptions,
            ...options,
        });

        return compressedFile
    } catch (error) {
        console.error(error)
        return file
    }
}

export default compressImage